import { anmClassificationCatalogEsES } from "./anm-classification/es-ES";
import { inspectionEsES } from "./inspection/es-ES";
import { regionalClassificationCatalogEsES } from "./regional-classification/es-ES";

export const esES = {
  inspection: inspectionEsES,
  test: "¡Si ves esto, i18next está funcionando!",
  operationalPermissions: {
    keys: {
      view: "Ver",
      create: "Crear",
      update: "Editar",
      delete: "Eliminar",
      upload: "Subir archivo",
      download: "Descargar",
    },
  },
  operationalModules: {
    selector: {
      title: "Seleccione una estructura",
      empty: "No hay estructuras disponibles para este módulo.",
    },
    placeholder: {
      underConstruction: "Este módulo está en construcción.",
    },
  },
  general: {
    comingSoon: {
      title: "Próximamente",
      description:
        "Este tipo de estructura aún no tiene panel en el módulo General.",
    },
    dashboard: {
      emptyValue: "—",
      loadError: "Error al cargar los datos.",
      button: {
        close: "Cerrar",
      },
      pagination: {
        showing: "Página {{current}} de {{total}}",
        previous: "Anterior",
        next: "Siguiente",
      },
      anmClassification: {
        title: "Clasificación ANM",
        modalTitle: "Ficha de Clasificación ANM",
        dpa: "DPA",
        cri: "CRI",
        go: "GO",
        sections: {
          ct: "Características Técnicas",
          ec: "Estado de Conservación",
          psb: "Plan de Seguridad",
          dpa: "Daño Potencial Asociado",
          go: "Gestión Operativa",
        },
      },
      regionalClassification: {
        title: "Clasificación Regional",
        modalTitle: "Ficha de Clasificación Regional",
        dpa: "DPA",
        cri: "CRI",
        state: "Estado:",
        norm: "Norma:",
        selectionsTitle: "Selecciones de la Norma Regional",
      },
      classificationDetail: {
        resultTitle: "Resultado de la clasificación",
        criteriaTitle: "Detalle por criterio",
        subtotal: "Subtotal",
      },
      generalData: {
        title: "Datos Generales",
        modalTitle: "Ficha de Datos Generales",
        responsibleCompany: "Empresa responsable",
        operationStartDate: "Inicio de la operación",
        operationEndDate: "Fin de la operación",
        coordinateSystem: "Sistema de coordenadas",
      },
      tenantSummary: {
        title: "GS3 / Cliente",
        modalTitle: "Ficha del Cliente",
        logoAlt: "Logo del cliente",
        clientName: "Cliente",
        fantasyName: "Nombre de Fantasía",
        cnpj: "CNPJ",
        cep: "Código Postal",
        responsibleName: "Responsable",
      },
      complex: {
        title: "Complejo",
        modalTitle: "Ficha del Complejo",
        name: "Complejo",
        cnpj: "CNPJ",
        cep: "Código Postal",
        responsibleName: "Responsable",
      },
      hydrology: {
        title: "Hidrología",
      },
      raisingHistory: {
        title: "Historial de Elevación",
        modalTitle: "Historial de Elevación",
      },
      geometry: {
        title: "Geometría del Macizo",
        modalTitle: "Ficha de Geometría",
      },
      reservoirManagement: {
        title: "Manejo del Embalse",
        modalTitle: "Manejo del Embalse",
      },
      riskMapping: {
        title: "Mapeo de Riesgos",
      },
      map: {
        title: "Mapa",
        noCoordinates: "Ninguna coordenada registrada",
      },
    },
  },
  sidebar: {
    modules: {
      general: "General",
      monitoring: "Monitoreo",
      inspection: "Inspección",
      actionPlan: "Plan de Acción",
      stabilityAnalysis: "Análisis de Estabilidad",
      eor: "Ingeniero de Registro (EoR)",
      ato: "ATO",
      psb: "PSB",
      gistm: "GISTM",
      paebm: "PAEBM",
      damBreakStudy: "Estudio de Rotura",
      riskAnalysis: "Análisis de Riesgo",
    },
  },
  auth: {
    selectClient: "Seleccionar cliente",
    management: "Administración",
    loadingOrganizations: "Cargando organizaciones...",
    errorLoadingOrganizations: "Error al cargar organizaciones",
    errorSelectingTenant: "Error al seleccionar organización",
    tryAgain: "Intentar de nuevo",
    logout: "Cerrar sesión",
    loading: "Cargando...",
    permissionDenied: "No tienes permiso",
    pagePermissionDenied: "No tienes permiso para acceder a esta página.",
    authError:
      "Error al verificar autenticación. Intente nuevamente. Si el problema persiste contacte a soporte",
    permissionError: "Error al verificar permisos",
  },
  common: {
    notFoundPage: {
      title: "Página no encontrada",
      description: "Lo sentimos, la página que buscas no existe o ha sido movida.",
      backToHome: "Volver al inicio",
      goBack: "Volver"
    },
    tellusAllRightsReserved:
      "Tellus Company® 2025 Todos los derechos reservados",
    error: "Error",
    management: "Gestión",
    admin: "Admin",
    item: "Elemento",
    loading: "Cargando...",
    deleteModalTitle: "Eliminar elemento permanentemente",
    deleteModalItemMessage: "Elemento a eliminar:",
    deleteModalAlertMessage:
      " Esta acción es irreversible. Los datos no podrán recuperarse tras la eliminación.",
    delete: "Eliminar",
    deleting: "Eliminando...",
    cancel: "Cancelar",
    toggleTheme: "Cambiar tema",
    deleteSuccess: "Eliminación exitosa",
    createSuccess: "Creación exitosa",
    editSuccess: "Edición exitosa",
    errorCreating: "Error al crear",
    errorEditing: "Error al editar",
    errorDeleting: "Error al eliminar",
    address: {
      countries: {
        brazil: "Brasil",
      },
      states: {
        acre: "Acre",
        alagoas: "Alagoas",
        amapa: "Amapá",
        amazonas: "Amazonas",
        bahia: "Bahía",
        ceara: "Ceará",
        distritoFederal: "Distrito Federal",
        espiritoSanto: "Espírito Santo",
        goias: "Goiás",
        maranhao: "Maranhão",
        matoGrosso: "Mato Grosso",
        matoGrossoDoSul: "Mato Grosso del Sur",
        minasGerais: "Minas Gerais",
        para: "Pará",
        paraiba: "Paraíba",
        parana: "Paraná",
        pernambuco: "Pernambuco",
        piaui: "Piauí",
        rioDeJaneiro: "Río de Janeiro",
        rioGrandeDoNorte: "Río Grande del Norte",
        rioGrandeDoSul: "Río Grande del Sur",
        rondonia: "Rondônia",
        roraima: "Roraima",
        santaCatarina: "Santa Catarina",
        saoPaulo: "São Paulo",
        sergipe: "Sergipe",
        tocantins: "Tocantins",
      },
    },
  },
  pagination: {
    rowsPerPage: "Filas por página",
    pageOf: "Página {{current}} de {{total}}",
    goToPage: "Ir a la página",
    goToPageAriaLabel: "Ir a la página",
    showingRange: "Mostrando {{start}}–{{end}} de {{total}}",
    showingEmpty: "No se encontraron registros",
  },
  management: {
    navbar: {
      management: "Gestión",
      users: "Usuarios",
      clients: "Clientes",
      complexes: "Complejos",
      structures: "Estructuras",
      licenses: "Licencias",
      log: "Registro",
      releaseNotes: "Notas de Versión",
      termsOfUse: "Términos de Uso",
      privacyPolicy: "Política de Privacidad",
    },
    users: {
      button: {
        new: "Nuevo Usuario",
        save: "Guardar",
        cancel: "Cancelar",
        edit: "Editar",
        delete: "Eliminar",
        filter: "Filtrar",
        clearFilters: "Limpiar Filtros",
      },
      form: {
        label: {
          name: "Nombre",
          email: "Email",
          role: "Tipo de acceso",
          phone: "Teléfono",
          department: "Departamento",
          position: "Función",
        },
        placeholder: {
          name: "Nombre Apellido",
          email: "nombre@empresa.com",
          roleSelect: "Seleccione...",
          department: "Ingeniería digital",
          position: "Diseñador UX/UI",
          filterName: "Ingrese el nombre",
          filterEmail: "Ingrese el email",
          filterRole: "Seleccione el tipo de acceso...",
        },
      },
      table: {
        column: {
          name: "Nombre",
          email: "Email",
          role: "Tipo de Acceso",
        },
        filterButtonText: "Filtros",
      },
      modal: {
        title: {
          create: "Registrar usuario",
          edit: "Editar usuario",
        },
      },
      filter: {
        status: {
          active: "Activo",
          inactive: "Inactivo",
        },
      },
      validation: {
        nameRequired: "El nombre es obligatorio",
        emailInvalid: "Email inválido",
        emailRequired: "El email es obligatorio",
        roleRequired: "El tipo de acceso es obligatorio",
        phoneRequired: "El teléfono es obligatorio",
      },
    },
    complexes: {
      button: {
        new: "Nuevo Complejo",
        save: "Guardar",
        cancel: "Cancelar",
        edit: "Editar",
        delete: "Eliminar",
        filter: "Filtrar",
        clearFilters: "Limpiar Filtros",
      },
      form: {
        section: {
          generalData: "Datos Generales",
          address: "Dirección",
          responsible: "Responsable",
        },
        label: {
          cnpj: "CNPJ",
          tradeName: "Nombre de Exhibición",
          companyPhone: "Teléfono (empresa)",
          municipalRegistration: "Inscripción Municipal",
          logo: "Logo",
          zipCode: "Código Postal",
          street: "Calle",
          complement: "Complemento",
          neighborhood: "Barrio",
          number: "Número",
          city: "Ciudad",
          state: "Estado",
          country: "País",
          responsibleName: "Nombre",
          responsibleEmail: "Email",
          responsiblePhone: "Teléfono (responsable)",
          complex: "Nombre del Complejo",
          phone: "Teléfono",
          responsible: "Responsable",
        },
        placeholder: {
          cnpj: "00.000.000/0000-00",
          complex: "Nombre del Complejo",
          tradeName: "Nombre de Exhibición",
          companyPhone: "(00) 00000-0000",
          municipalRegistration: "123456789",
          zipCode: "00000-000",
          street: "Calle, Avenida, etc",
          complement: "Sala, Piso, etc",
          neighborhood: "Nombre del barrio",
          number: "123",
          city: "Nombre de la ciudad",
          state: "Seleccione el estado",
          country: "Seleccione el país",
          responsibleName: "Nombre Apellido",
          responsibleEmail: "nombre@empresa.com",
          responsiblePhone: "(00) 00000-0000",
          filterComplex: "Ingrese el nombre del complejo",
          filterPhone: "Ingrese el teléfono",
          filterResponsible: "Ingrese el nombre del responsable",
        },
      },
      table: {
        column: {
          complex: "Complejo",
          phone: "Teléfono",
          responsible: "Responsable",
        },
        filterButtonText: "Filtros",
      },
      modal: {
        title: {
          create: "Registrar complejo",
          edit: "Editar complejo",
        },
      },
      validation: {
        cnpjRequired: "CNPJ es obligatorio",
        cnpjInvalid: "CNPJ inválido. Formato esperado: 00.000.000/0000-00",
        companyRequired: "La empresa es obligatoria",
        tradeNameRequired: "El nombre de exhibición es obligatorio",
        companyPhoneRequired: "El teléfono de la empresa es obligatorio",
        telefoneInvalid: "Teléfono inválido. Formato esperado: (00) 00000-0000",
        municipalRegistrationRequired: "La inscripción municipal es obligatoria",
        logoRequired: "El logo es obligatorio",
        logoInvalidType: "El logo debe ser una imagen JPEG, JPG o PNG",
        zipCodeRequired: "El código postal es obligatorio",
        zipCodeInvalid: "Código postal inválido. Formato esperado: 00000-000",
        streetRequired: "La calle es obligatoria",
        neighborhoodRequired: "El barrio es obligatorio",
        numberRequired: "El número es obligatorio",
        numberInvalid: "Indique un número entero válido",
        cityRequired: "La ciudad es obligatoria",
        stateRequired: "El estado es obligatorio",
        countryRequired: "El país es obligatorio",
        responsibleNameRequired: "El nombre del responsable es obligatorio",
        responsibleEmailRequired: "El email del responsable es obligatorio",
        emailInvalid: "Email inválido",
        responsiblePhoneRequired:
          "El teléfono del responsable es obligatorio",
      },
    },
    clients: {
      button: {
        new: "Nuevo Cliente",
        save: "Guardar",
        cancel: "Cancelar",
        edit: "Editar",
        delete: "Eliminar",
        filter: "Filtrar",
        clearFilters: "Limpiar Filtros",
      },
      form: {
        section: {
          generalData: "Datos Generales",
          address: "Dirección",
          responsible: "Responsable",
        },
        label: {
          cnpj: "CNPJ",
          company: "Empresa",
          tradeName: "Nombre Comercial",
          companyPhone: "Teléfono (empresa)",
          municipalRegistration: "Inscripción Municipal",
          logo: "Logo",
          zipCode: "Código Postal",
          street: "Calle",
          complement: "Complemento",
          neighborhood: "Barrio",
          number: "Número",
          city: "Ciudad",
          state: "Estado",
          country: "País",
          responsibleName: "Nombre",
          responsibleEmail: "Email",
          responsiblePhone: "Teléfono (responsable)",
          client: "Cliente",
          responsible: "Responsable",
        },
        placeholder: {
          cnpj: "00.000.000/0000-00",
          company: "Nombre de la empresa",
          tradeName: "Nombre comercial",
          companyPhone: "(00) 00000-0000",
          municipalRegistration: "123456789",
          zipCode: "00000-000",
          street: "Calle, Avenida, etc",
          complement: "Sala, Piso, etc",
          neighborhood: "Nombre del barrio",
          number: "123",
          city: "Nombre de la ciudad",
          state: "Seleccione el estado",
          country: "Seleccione el país",
          responsibleName: "Nombre Apellido",
          responsibleEmail: "nombre@empresa.com",
          responsiblePhone: "(00) 00000-0000",
          filterClient: "Ingrese el nombre del cliente",
          filterTradeName: "Ingrese el nombre comercial",
          filterCnpj: "Ingrese el CNPJ",
          filterResponsible: "Ingrese el nombre del responsable",
        },
      },
      table: {
        column: {
          client: "Cliente",
          tradeName: "Nombre Comercial",
          cnpj: "CNPJ",
          responsible: "Responsable",
        },
        filterButtonText: "Filtros",
      },
      modal: {
        title: {
          create: "Registrar cliente",
          edit: "Editar cliente",
        },
      },
      validation: {
        cnpjRequired: "CNPJ es obligatorio",
        cnpjInvalid: "CNPJ inválido. Formato esperado: 00.000.000/0000-00",
        companyRequired: "La empresa es obligatoria",
        tradeNameRequired: "El nombre comercial es obligatorio",
        companyPhoneRequired: "El teléfono de la empresa es obligatorio",
        telefoneInvalid: "Teléfono inválido. Formato esperado: (00) 00000-0000",
        municipalRegistrationRequired: "La inscripción municipal es obligatoria",
        logoRequired: "El logo es obligatorio",
        logoInvalidType: "El logo debe ser una imagen JPEG, JPG o PNG",
        zipCodeRequired: "El código postal es obligatorio",
        zipCodeInvalid: "Código postal inválido. Formato esperado: 00000-000",
        streetRequired: "La calle es obligatoria",
        neighborhoodRequired: "El barrio es obligatorio",
        numberRequired: "El número es obligatorio",
        numberInvalid: "Indique un número entero válido",
        cityRequired: "La ciudad es obligatoria",
        stateRequired: "El estado es obligatorio",
        countryRequired: "El país es obligatorio",
        responsibleNameRequired: "El nombre del responsable es obligatorio",
        responsibleEmailRequired: "El email del responsable es obligatorio",
        emailInvalid: "Email inválido",
        responsiblePhoneRequired:
          "El teléfono del responsable es obligatorio",
      },
    },
    structures: {
      button: {
        new: "Nueva Estructura",
        save: "Guardar",
        cancel: "Cancelar",
        edit: "Editar",
        delete: "Eliminar",
        filter: "Filtrar",
        clearFilters: "Limpiar Filtros",
      },
      form: {
        section: {
          coordinates: "Coordenadas de la Estructura",
        },
        label: {
          structure: "Estructura",
          name: "Nombre",
          complex: "Complejo",
          complexName: "Complejo",
          coordinateSystem: "Sistema de Coordenadas",
          coordinateE: "Coordenada E",
          coordinateN: "Coordenada N",
          radiusKm: "Radio (Km)",
          client: "Cliente",
        },
        placeholder: {
          structure: "Nombre de la estructura",
          coordinateSystem: "Seleccione...",
          coordinateE: "Coordenada E",
          coordinateN: "Coordenada N",
          radiusKm: "0",
          name: "Nombre de la estructura",
          complexSelect: "Seleccione un complejo",
          filterName: "Ingrese el nombre de la estructura",
          filterComplexName: "Ingrese el nombre del complejo",
          filterStructure: "Ingrese el nombre de la estructura",
          clientSelect: "Seleccione un cliente",
        },
      },
      table: {
        column: {
          structure: "Estructura",
          name: "Nombre",
          complexName: "Complejo",
        },
        filterButtonText: "Filtros",
      },
      modal: {
        title: {
          create: "Registrar estructura",
          edit: "Editar estructura",
        },
      },
      validation: {
        nameRequired: "El nombre es obligatorio",
        complexRequired: "El complejo es obligatorio",
        structureRequired: "La estructura es obligatoria",
        coordinateSystemRequired: "El sistema de coordenadas es obligatorio",
        coordinateERequired: "La coordenada E es obligatoria",
        coordinateNRequired: "La coordenada N es obligatoria",
        radiusKmRequired: "El radio (Km) es obligatorio",
        radiusKmMustBeNumber: "El radio (Km) debe ser un número",
      },
    },
    releaseNotes: {
      button: {
        addNewVersion: "Agregar nueva versión",
        save: "Guardar",
        cancel: "Cancelar",
      },
      form: {
        label: {
          file: "Archivo",
          version: "Versión del archivo",
        },
        placeholder: {
          version: "Ej.: 1.0.0",
        },
      },
      modal: {
        title: {
          create: "Agregar nueva versión",
        },
      },
      validation: {
        fileRequired: "El archivo es obligatorio",
        fileInvalidType: "El archivo debe ser un PDF",
        versionRequired: "La versión es obligatoria",
      },
    },
    termsOfUse: {
      noFileUploaded: "Aún no se ha subido ningún archivo",
      button: {
        addNewVersion: "Agregar nueva versión",
        save: "Guardar",
        cancel: "Cancelar",
      },
      form: {
        label: {
          file: "Archivo",
          version: "Versión del archivo",
        },
        placeholder: {
          version: "Ej.: 1.0.0",
        },
      },
      modal: {
        title: {
          create: "Agregar nueva versión",
        },
      },
      validation: {
        fileRequired: "El archivo es obligatorio",
        fileTooLarge: "El archivo debe tener como máximo 20MB",
        fileInvalidType: "El archivo debe ser un PDF",
      },
    },
    privacyPolicy: {
      noFileUploaded: "Aún no se ha subido ningún archivo",
      button: {
        addNewVersion: "Agregar nueva versión",
        save: "Guardar",
        cancel: "Cancelar",
      },
      form: {
        label: {
          file: "Archivo",
          version: "Versión del archivo",
        },
        placeholder: {
          version: "Ej.: 1.0.0",
        },
      },
      modal: {
        title: {
          create: "Agregar nueva versión",
        },
      },
      validation: {
        fileRequired: "El archivo es obligatorio",
        fileTooLarge: "El archivo debe tener como máximo 20MB",
        fileInvalidType: "El archivo debe ser un PDF",
      },
    },
    log: {
      page: {
        title: "Registros",
        description: "Visualice la actividad del sistema y los registros de auditoría.",
      },
      button: {
        export: "Exportar",
      },
      form: {
        label: {
          columns: "Columnas",
          startDate: "Fecha Inicial",
          endDate: "Fecha Final",
        },
        placeholder: {
          columns: "Seleccione las columnas...",
          searchColumns: "Buscar columnas...",
          notFound: "Ninguna columna encontrada",
          notMoreOptions: "No hay más opciones",
        },
      },
      columns: {
        user: "Usuario",
        action: "Acción",
        date: "Fecha",
        ip: "IP",
        module: "Módulo",
      },
      validation: {
        columnsRequired: "Las columnas son obligatorias",
        startDateRequired: "La fecha inicial es obligatoria",
        endDateRequired: "La fecha final es obligatoria",
        dateRangeInvalid:
          "La fecha final debe ser igual o posterior a la fecha inicial",
      },
    },
    licenses: {
      button: {
        new: "Nueva Licencia",
        save: "Guardar",
        cancel: "Cancelar",
        edit: "Editar",
        delete: "Eliminar",
        view: "Ver",
        filter: "Filtrar",
        clearFilters: "Limpiar Filtros",
      },
      form: {
        label: {
          client: "Cliente",
          clientEmail: "Email Cliente",
          managerEmail: "Email Gerente GS3",
          complex: "Complejo",
          structure: "Estructura",
          module: "Módulo",
          licenses: "Licencias",
          startDate: "Fecha de inicio",
          endDate: "Fecha final",
          notificationPeriods: "Período de notificación",
          days: "días",
          tenant: "Tenant",
        },
        placeholder: {
          client: "Seleccione un cliente",
          clientEmail: "email@cliente.com",
          managerEmail: "gerente@gs3.com",
          complex: "Seleccione un complejo",
          structure: "Seleccione una estructura",
          module: "Seleccione un módulo",
          licenses: "0",
          notificationPeriods: "Agregar período...",
          filterComplex: "Ingrese el nombre del complejo",
          filterStructure: "Ingrese el nombre de la estructura",
          filterModule: "Seleccione un módulo",
          filterLicenses: "Ingrese la cantidad",
        },
      },
      table: {
        column: {
          complex: "Complejo",
          structure: "Estructura",
          module: "Módulo",
          licenses: "Licencias",
          accessPeriod: "Período de acceso",
        },
        filterButtonText: "Filtros",
      },
      modal: {
        title: {
          create: "Registrar licencia",
          edit: "Editar licencia",
          view: "Detalles de la licencia",
        },
      },
      validation: {
        clientRequired: "El cliente es obligatorio",
        clientEmailRequired: "El email del cliente es obligatorio",
        managerEmailRequired: "El email del gerente es obligatorio",
        emailInvalid: "Email inválido",
        complexRequired: "El complejo es obligatorio",
        structureRequired: "La estructura es obligatoria",
        moduleRequired: "El módulo es obligatorio",
        licensesRequired: "Las licencias son obligatorias",
        licensesInvalid: "Indique un número entero válido de licencias",
        startDateRequired: "La fecha de inicio es obligatoria",
        endDateRequired: "La fecha final es obligatoria",
        notificationPeriodsMax: "Máximo 3 períodos de notificación",
        notificationPeriodAlreadyExists: "Este período ya ha sido agregado",
        notificationPeriodsMin:
          "Agregue al menos 1 período de notificación",
      },
    },
  },
  home: {
    welcome: {
      title: "Bienvenido(a) a GS3",
      subtitle: "Seleccione un módulo en el menú lateral para comenzar.",
    },
    hero: {
      badge: "Sistema en desarrollo",
      tagline: "El futuro del monitoreo de represas está llegando",
      subtitle:
        "Estamos construyendo una plataforma completa para la gestión y monitoreo de seguridad de represas. Siga el progreso de cada módulo a continuación.",
    },
    modules: {
      title: "Módulos del Sistema",
      badgeActive: "En desarrollo",
      badgeSoon: "Próximamente",
      badgeCompleted: "Completado",
      progress: "Progreso",
      authenticationAndSecurity: {
        name: "Autenticación y Seguridad",
        description:
          "Módulos de autenticación, autorización y gestión de usuarios",
      },
      administrative: {
        name: "Administrativo",
        description: "Funciones administrativas para usuarios Admin",
      },
      general: { name: "General", description: "Vista general del sistema" },
      monitoring: {
        name: "Monitoreo",
        description: "Monitoreo continuo de instrumentos",
      },
      inspections: {
        name: "Inspecciones",
        description: "Registro y gestión de inspecciones de campo",
      },
      actionPlan: {
        name: "Plan de Acción",
        description: "Planes de acción y seguimiento de actividades",
      },
      stability: {
        name: "Estabilidad",
        description: "Análisis de estabilidad de taludes",
      },
      eor: {
        name: "EoR",
        description: "Clasificación y encuadramiento de represas",
      },
      ato: {
        name: "ATO",
        description: "Autorización de operación de estructuras",
      },
      psb: { name: "PSB", description: "Plan de seguridad de represa" },
      gistm: {
        name: "GISTM",
        description: "Estándar global de gestión de relaves",
      },
      paebm: { name: "PAEBM", description: "Plan de acción de emergencia" },
      damBreak: {
        name: "Rotura de Presa",
        description: "Simulación de rotura y zonas de autosalvamento",
      },
      riskAnalysis: {
        name: "Análisis de Riesgo",
        description: "Evaluación y clasificación de riesgos",
      },
      report: {
        name: "Informes",
        description: "Generación de informes técnicos",
      },
      dashboard: {
        name: "Dashboard",
        description: "Paneles de indicadores y métricas",
      },
      cmg: { name: "CMG", description: "Gestión de mantenimiento y control" },
      managerial: {
        name: "Gestión",
        description: "Gestión de usuarios, clientes y licencias",
      },
    },
    map: {
      title: "Área de cobertura monitoreada",
    },
  },
  legalDocuments: {
    modal: {
      version: "Versión",
      accept: "Aceptar",
      termsOfUse: {
        title: "Términos de Uso",
        readConfirm: "He leído y acepto los Términos de Uso",
      },
      privacyPolicy: {
        title: "Política de Privacidad",
        readConfirm: "He leído y acepto la Política de Privacidad",
      },
    },
  },
  errors: {
    errorFallback: "Error inesperado",
    error1: "Solicitud inválida. Actualice la página e intente nuevamente",
    error2: "Usuario no encontrado",
    error3: "Su sesión ha expirado. Inicie sesión nuevamente",
    error4: "Seleccione una organización para continuar",
    error5: "La organización seleccionada no está disponible",
    error6: "No tiene acceso a esta organización",
    error7: "Sesión expirada. Por favor, inicie sesión nuevamente",
    error8: "Su sesión ha expirado. Inicie sesión nuevamente",
    error9:
      "No fue posible validar su dispositivo. Actualice la página e intente nuevamente",
    error10:
      "No fue posible completar. Actualice la página e intente nuevamente",
    error11:
      "Esta organización aún no está disponible. Intente más tarde o contacte al soporte",
    error12: "No tiene permiso para esta acción",
    error13: "Ya existe un usuario registrado con este correo electrónico",
    error14: "Ya existe un ambiente registrado con este CNPJ",
    error15: "Tipo de archivo no permitido",
    error16: "Archivo demasiado grande (máximo 20 MB)",
    error17: "El envío del archivo es obligatorio",
    error18: "Documento legal no encontrado",
    error19: "Ya ha aceptado este documento",
    error20: "Ya existe un complejo registrado con este CNPJ",
    error21: "Complejo no encontrado",
    error22: "Ya existe una estructura con este nombre para el complejo seleccionado",
    error23: "Estructura no encontrada",
    error24: "El módulo seleccionado no está disponible",
    error25: "La estructura ya posee una licencia vigente para este módulo",
    error26: "Licencia no encontrada",
    error27: "Acceso denegado",
    error28: "Recurso no encontrado",
    error29:
      "Este usuario no puede ser promovido a Super Admin (ya tiene un rol administrativo)",
    error30: "Este usuario no es Super Admin",
    error31: "Este usuario ya es admin de este complejo",
    error32:
      "Capacidad de licencias agotada. Revoque una asignación existente o amplíe su plan",
    error33: "Este usuario ya tiene esta licencia asignada",
    error34:
      "No es posible editar permisos de este usuario (rol administrativo)",
    error35: "Este módulo no está disponible en la estructura seleccionada",
    error36: "El módulo seleccionado no es válido para este contexto",
    error37:
      "Uno o más permisos seleccionados no existen para este módulo",
    error38: "Este perfil de usuario no recibe asignación de licencia",
    error54:
      "Complete todos los campos obligatorios del alzamiento antes de guardar",
    error55:
      "Revise los datos del alzamiento: la elevación debe ser un número (ej.: 845,25), la fecha debe ser válida y el método debe estar en la lista",
    error56: "Línea de alzamiento no encontrada",
    error77: "Inspección no encontrada",
    error78: "Participante de la inspección no encontrado",
    error79:
      "Filtros o paginación no válidos. Ajuste los criterios e intente de nuevo",
    error80:
      "No se pudo guardar. Revise los datos de la ficha e intente de nuevo",
    error81: "Esta inspección no puede modificarse en el estado actual",
    error82: "Esta inspección no puede eliminarse",
    error83: "No es posible finalizar esta inspección ahora",
    error84: "La fecha de una inspección programada no puede modificarse",
    error85:
      "Complete la ficha y las evidencias obligatorias antes de finalizar",
    error86: "Todos los participantes deben firmar antes de finalizar",
    error87: "Este participante no puede eliminarse",
    error88:
      "No se pudo enviar la foto. Verifique el tipo de archivo y el estado de la inspección",
    error89:
      "Fuente de firma no válida. Elija una de las fuentes disponibles",
    error90:
      "No se pudo generar el PDF. La inspección sigue en curso. Intente finalizar de nuevo",
    error91: "El informe PDF aún no está disponible",
    error92: "Indique una fecha de inspección válida (no puede ser futura)",
    error93:
      "El nombre de un participante registrado en el sistema no puede modificarse en esta ficha",
    error94:
      "Una inspección programada solo puede editarse el día previsto",
    error97: "Este participante ya está en la inspección",
    error98: "Solicitud no válida. Actualice la página e inténtelo de nuevo",
    error99: "Solicitud no válida. Actualice la página e inténtelo de nuevo",
    error100:
      "El idioma indicado no es válido. Elija un idioma del menú e inténtelo de nuevo",
    error101:
      "El tema indicado no es válido. Actualice la página e inténtelo de nuevo",
    boundary: {
      network: {
        title: "Error de conexión",
        message: "No fue posible conectar con el servidor.",
        suggestion: "Verifica tu conexión a internet e inténtalo nuevamente.",
      },
      unexpected: {
        title: "Error inesperado",
        message: "Ocurrió un error inesperado. Inténtalo nuevamente.",
        suggestion: "Si el problema persiste, comunícate con soporte.",
      },
      unknown: {
        title: "Error desconocido",
        message: "Ocurrió un error inesperado.",
        suggestion: "Intenta recargar la página.",
      },
      unauthorized: {
        title: "No autenticado",
        message: "Debes iniciar sesión para acceder a esta página.",
        suggestion: "Por favor, inicia sesión e inténtalo nuevamente.",
      },
      forbidden: {
        title: "Acceso denegado",
        message: "No tienes permiso para acceder a este recurso.",
        suggestion:
          "Comunícate con el administrador si necesitas acceso.",
      },
      notFound: {
        title: "Página no encontrada",
        message: "La página que buscas no existe.",
        suggestion: "Verifica la dirección o vuelve al inicio.",
      },
      serverError: {
        title: "Error del servidor",
        message: "Ocurrió un error interno del servidor.",
        suggestion: "Inténtalo nuevamente en unos instantes.",
      },
      serviceUnavailable: {
        title: "Servicio no disponible",
        message: "El servidor está temporalmente no disponible.",
        suggestion:
          "Estamos trabajando para resolverlo. Inténtalo nuevamente pronto.",
      },
      default: {
        title: "Error",
        message: "Ocurrió un error inesperado.",
      },
    },
    appBoundary: {
      title: "Algo salió mal",
      description: "Ocurrió un error inesperado. Por favor, inténtalo nuevamente.",
      details: "Detalles del Error:",
      stackTrace: "Stack Trace",
      retry: "Intentar nuevamente",
      reload: "Recargar página",
      goHome: "Ir al inicio",
    },
  },
  admin: {
    tabs: {
      users: "Usuarios",
      access: "Accesos",
      complexes: "Complejos",
      structures: "Estructuras",
      licenseInventory: "Licencias",
      licenseAssignments: "Asignaciones",
      permissions: "Permisos",
    },
    access: {
      page: {
        title: "Accesos",
        subtitle:
          "Gestione qué usuarios son admins de complejos específicos.",
      },
      complexAdmins: {
        sectionTitle: "Admins de Complejo",
        sectionDescription:
          "Los Admins de Complejo tienen permisos dentro de un complejo específico. Solo el Owner puede asignar.",
        button: {
          assign: "Asignar admin de complejo",
          remove: "Eliminar",
        },
        filter: {
          allComplexes: "Todos los complejos",
          complexLabel: "Filtrar por complejo",
        },
        modal: {
          assignTitle: "Asignar admin de complejo",
          removeTitle: "Eliminar admin de complejo",
          removeMessage:
            "¿Está seguro de que desea eliminar esta asignación? El usuario dejará de administrar este complejo.",
        },
        table: {
          filterButtonText: "Filtros",
          column: {
            user: "Usuario",
            email: "Correo electrónico",
            complex: "Complejo",
            createdAt: "Asignado el",
          },
          empty: "Sin asignaciones registradas.",
        },
      },
      form: {
        label: {
          user: "Usuario",
          complex: "Complejo",
        },
        placeholder: {
          selectUser: "Seleccione un usuario...",
          selectComplex: "Seleccione un complejo...",
        },
        validation: {
          userRequired: "Seleccione un usuario",
          complexRequired: "Seleccione un complejo",
        },
        empty: {
          eligibleUsers: "Sin usuarios elegibles disponibles.",
        },
      },
      forbidden: "No tiene permisos para ver esta pestaña.",
    },
    complexes: {
      page: {
        title: "Complejos",
        subtitle: "Visualice los complejos disponibles en su tenant.",
      },
      button: {
        viewDetails: "Ver detalles",
        close: "Cerrar",
        filter: "Filtrar",
        clearFilters: "Limpiar Filtros",
      },
      table: {
        filterButtonText: "Filtros",
        column: {
          name: "Nombre",
          fantasyName: "Nombre Comercial",
          cnpj: "CNPJ",
          responsibleName: "Responsable",
        },
      },
      filter: {
        label: {
          name: "Nombre",
          fantasyName: "Nombre Comercial",
          cnpj: "CNPJ",
          responsibleName: "Responsable",
        },
        placeholder: {
          name: "Escriba el nombre",
          fantasyName: "Escriba el nombre comercial",
          cnpj: "Escriba el CNPJ",
          responsibleName: "Escriba el nombre del responsable",
        },
      },
      details: {
        title: "Detalles del complejo",
        section: {
          identification: "Identificación",
          contact: "Contacto",
          address: "Dirección",
        },
        label: {
          name: "Nombre",
          fantasyName: "Nombre Comercial",
          cnpj: "CNPJ",
          municipalRegistration: "Registro Municipal",
          complexPhone: "Teléfono del complejo",
          responsibleName: "Responsable",
          responsiblePhone: "Teléfono",
          phone: "Teléfono",
          zipCode: "Código Postal",
          street: "Calle",
          number: "Número",
          complement: "Complemento",
          neighborhood: "Barrio",
          city: "Ciudad",
          state: "Estado",
          country: "País",
        },
        empty: "Sin información de dirección.",
        notProvided: "—",
        loadError: "Error al cargar los detalles del complejo.",
      },
    },
    structures: {
      page: {
        title: "Estructuras",
        subtitle:
          "Visualice las estructuras de cada complejo. Seleccione un complejo para comenzar.",
      },
      complexSelector: {
        label: "Complejo",
        placeholder: "Seleccione un complejo...",
        empty: "Seleccione un complejo arriba para ver las estructuras.",
      },
      table: {
        filterButtonText: "Filtros",
        column: {
          name: "Nombre",
          type: "Tipo",
          operationalStatus: "Estado operacional",
          coordinateX: "Coordenada X",
          coordinateY: "Coordenada Y",
          actions: "Acciones",
        },
        action: {
          details: "Detalles",
        },
      },
      filter: {
        label: {
          name: "Nombre",
          type: "Tipo",
          operationalStatus: "Estado operacional",
        },
        placeholder: {
          name: "Escriba el nombre",
          type: "Seleccione el tipo",
          operationalStatus: "Seleccione el estado",
        },
        button: {
          filter: "Filtrar",
          clearFilters: "Limpiar Filtros",
        },
      },
      structureType: {
        dam: "Presa",
        stockpile: "Pila",
        openPit: "Cava",
      },
      operationalStatus: {
        decommissioned: "Descaracterizado",
        underConstruction: "En construcción",
        inOperation: "En operación",
        underConstructionAndOperation: "En construcción/operación",
        underDecommissioning: "En descaracterización",
        halted: "Paralizado",
      },
      modal: {
        title: "Registrar datos de la estructura",
        button: {
          close: "Cerrar",
          cancel: "Cancelar",
          save: "Guardar",
        },
        tab: {
          generalData: "Datos generales",
          raisingHistory: "Historial de elevación",
          geometryDam: "Geometría del macizo",
          geometry: "Geometría",
          hydrology: "Hidrología",
          reservoirManagement: "Manejo del embalse",
          anmClassification: "Clasificación ANM",
          regionalClassification: "Clasificación regional",
          riskMapping: "Mapeo de riesgo",
        },
      },
      generalData: {
        label: {
          name: "Nombre",
          type: "Tipo",
          responsibleCompany: "Empresa responsable",
          operationalStatus: "Estado operacional",
          operationStartDate: "Inicio de operación",
          operationEndDate: "Fin de operación",
          centralPointSystem: "Sistema de coordenadas",
          centralPointE: "Coordenada E",
          centralPointN: "Coordenada N",
          pinSystem: "Sistema de coordenadas",
          pinE: "Coordenada E",
          pinN: "Coordenada N",
          utmEnabled: "UTM",
          utmZone: "Zona UTM",
          utmHemisphere: "Hemisferio",
          orthophoto: "Ortofoto",
        },
        section: {
          centralPointDam: "Coordenadas del punto central de la cresta",
          centralPointTop: "Coordenadas del punto central del tope",
          pin: "Coordenadas del pin",
          pinInfoTooltip:
            "Coordenadas opcionales usadas solo para centrar el mapa en la estructura. Cuando las coordenadas oficiales del punto central no quedan visualmente en el centro, el pin ajusta el marcador en el mapa sin modificar los datos registrales.",
          pinInfoAriaLabel: "Información sobre las coordenadas del pin",
        },
        coordinateSystem: {
          sirgas2000: "SIRGAS2000",
          astrochua: "ASTROCHUA",
          corregoAlegre: "CORREGO ALEGRE",
          sad69: "SAD69",
          wgs84: "WGS84",
        },
        utmHemisphere: {
          north: "Norte",
          south: "Sur",
        },
        button: {
          uploadOrthophoto: "Enviar ortofoto",
        },
        placeholder: {
          type: "Seleccione el tipo",
          orthophoto: "Seleccione un archivo .tif",
        },
        validation: {
          typeRequired: "Seleccione el tipo de estructura",
          responsibleCompanyRequired: "Indique la empresa responsable",
          operationalStatusRequired: "Seleccione el estado operacional",
          operationStartDateRequired: "Indique la fecha de inicio de operación",
          centralPointSystemRequired:
            "Seleccione el sistema de coordenadas del punto central",
          centralPointERequired: "Indique la coordenada E del punto central",
          centralPointNRequired: "Indique la coordenada N del punto central",
          pinGroupIncomplete:
            "Complete todos los campos del pin o deje el grupo vacío",
          utmZoneRequired: "Indique la zona UTM",
          utmHemisphereRequired: "Seleccione el hemisferio UTM",
          utmZoneOutOfRange: "La zona UTM debe estar entre 1 y 60",
          formInvalidTitle: "Complete los campos obligatorios",
          formInvalidDescription:
            "Corrija los campos destacados abajo antes de guardar.",
          decimalInvalid:
            "Indique un número válido (use punto o coma como separador decimal)",
        },
      },
      geometry: {
        label: {
          crestElevation: "Elevación de la cresta (m)",
          damHeight: "Altura de la presa (m)",
          crestLength: "Longitud de la cresta (m)",
          crestWidth: "Ancho de la cresta (m)",
          typicalBermWidth: "Ancho típico de bermas (m)",
          upstreamSlopeInclination: "Inclinación talud monte arriba (°)",
          downstreamSlopeInclination: "Inclinación talud aguas abajo (°)",
          betweenBermsSlopeInclination: "Inclinación talud entre bermas (°)",
          globalDownstreamSlopeInclination: "Inclinación talud global aguas abajo (°)",
          benchSlopeInclination: "Inclinación del talud de bancada (°)",
          globalSlopeInclination: "Inclinación del talud global (°)",
          pitHeight: "Altura (m)",
          sectors: "Sectores",
          benchHeight: "Altura de bancadas (m)",
          benchInclination: "Inclinación de bancadas (°)",
          referenceDocument: "Documento de referencia",
        },
        validation: {
          crestElevationRequired: "Indique la elevación de la cresta",
          damHeightRequired: "Indique la altura de la presa",
          crestLengthRequired: "Indique la longitud de la cresta",
          crestWidthRequired: "Indique el ancho de la cresta",
          typicalBermWidthRequired: "Indique el ancho típico de bermas",
          upstreamSlopeInclinationRequired:
            "Indique la inclinación del talud monte arriba",
          downstreamSlopeInclinationRequired:
            "Indique la inclinación del talud aguas abajo",
          betweenBermsSlopeInclinationRequired:
            "Indique la inclinación del talud entre bermas",
          globalDownstreamSlopeInclinationRequired:
            "Indique la inclinación del talud global aguas abajo",
          benchSlopeInclinationRequired:
            "Indique la inclinación del talud de bancada",
          globalSlopeInclinationRequired:
            "Indique la inclinación del talud global",
          sectorsRequired: "Indique los sectores",
          sectorsInvalid: "Indique un número entero mayor o igual a cero",
          pitHeightRequired: "Indique la altura",
          benchHeightRequired: "Indique la altura de bancadas",
          benchInclinationRequired: "Indique la inclinación de bancadas",
          referenceDocumentRequired: "Indique el documento de referencia",
          decimalInvalid:
            "Indique un número válido (use punto o coma como separador decimal)",
        },
      },
      raisingHistory: {
        label: {
          raisingCount: "Número de elevaciones",
          executiveProjectDesigner: "Proyecto ejecutivo (proyectista)",
          stage: "Etapa",
          method: "Método",
          elevation: "Elevación (m)",
          elevationShort: "Elevación",
          occurredOn: "Fecha",
        },
        method: {
          downstream: "Aguas abajo",
          upstream: "Aguas arriba",
          centerLine: "Línea de centro",
        },
        button: {
          register: "Registrar",
          edit: "Editar",
          delete: "Eliminar",
          confirm: "Confirmar",
        },
        table: {
          filterButtonText: "Filtrar",
        },
        filter: {
          label: {
            stage: "Etapa",
            method: "Método",
          },
          placeholder: {
            stage: "Filtrar por etapa",
            method: "Filtrar por método",
          },
          button: {
            clearFilters: "Limpiar filtros",
          },
        },
        modal: {
          createTitle: "Nueva elevación",
          editTitle: "Editar elevación",
          deleteTitle: "Eliminar elevación",
          deleteMessage: "¿Desea eliminar esta elevación?",
        },
        validation: {
          executiveProjectDesignerRequired:
            "Indique el proyecto ejecutivo (proyectista)",
          stageRequired: "Indique la etapa",
          methodRequired: "Seleccione el método",
          elevationRequired: "Indique la elevación",
          elevationInvalid:
            "Indique la elevación en metros usando solo números (ej.: 845,25)",
          occurredOnRequired: "Indique la fecha",
          occurredOnInvalid: "Indique una fecha válida",
        },
      },
      reservoirManagement: {
        label: {
          occupiedArea: "Área ocupada por el embalse (m²)",
          occupiedAreaShort: "Área ocupada (m²)",
          totalVolume: "Volumen total del embalse (m³)",
          totalVolumeShort: "V. total (m³)",
          totalOccupiedVolume: "Volumen total ocupado (m³)",
          totalOccupiedVolumeShort: "V. total ocupado (m³)",
          availableVolume: "Volumen disponible (m³)",
          availableVolumeShort: "V. disponible (m³)",
          rejectOccupiedVolume: "Volumen ocupado por relaves (m³)",
          rejectOccupiedVolumeShort: "V. ocupado relaves (m³)",
          waterOccupiedVolume: "Volumen ocupado por agua (m³)",
          waterOccupiedVolumeShort: "V. ocupado por agua (m³)",
          waterLevel: "Nivel de agua",
          recordedOn: "Fecha",
        },
        button: {
          register: "Registrar",
          edit: "Editar",
          delete: "Eliminar",
          confirm: "Confirmar",
        },
        table: {
          filterButtonText: "Filtrar",
        },
        filter: {
          label: {
            recordedOn: "Fecha",
          },
          button: {
            clearFilters: "Limpiar filtros",
          },
        },
        modal: {
          createTitle: "Nuevo manejo",
          editTitle: "Editar manejo",
          deleteTitle: "Eliminar manejo",
          deleteMessage: "¿Desea eliminar este registro de manejo?",
        },
        validation: {
          occupiedAreaRequired: "Indique el área ocupada por el embalse",
          occupiedAreaInvalid: "Indique el área ocupada usando solo números",
          totalVolumeRequired: "Indique el volumen total del embalse",
          totalVolumeInvalid: "Indique el volumen total usando solo números",
          totalOccupiedVolumeRequired: "Indique el volumen total ocupado",
          totalOccupiedVolumeInvalid:
            "Indique el volumen total ocupado usando solo números",
          availableVolumeRequired: "Indique el volumen disponible",
          availableVolumeInvalid:
            "Indique el volumen disponible usando solo números",
          rejectOccupiedVolumeRequired:
            "Indique el volumen ocupado por relaves",
          rejectOccupiedVolumeInvalid:
            "Indique el volumen ocupado por relaves usando solo números",
          waterOccupiedVolumeRequired: "Indique el volumen ocupado por agua",
          waterOccupiedVolumeInvalid:
            "Indique el volumen ocupado por agua usando solo números",
          waterLevelRequired: "Indique el nivel de agua",
          waterLevelInvalid: "Indique el nivel de agua usando solo números",
          recordedOnRequired: "Indique la fecha",
          recordedOnInvalid: "Indique una fecha válida",
        },
      },
      anmClassification: {
        classification: {
          high: "Alto",
          medium: "Medio",
          low: "Bajo",
        },
        label: {
          criBignumberTitle: "Clasificación de riesgo (CRI)",
          dpaBignumberTitle: "Daño potencial asociado (DPA)",
          goBignumberTitle: "Gestión operacional (GO)",
          referenceDocButton: "Documentación de referencia {{section}}",
          referenceDocPanel: "Documentación de referencia — {{section}}",
          close: "Cerrar",
          total: "Total {{section}}",
          classificationStatus: "Clasificación {{section}}",
          partial: "Parcial {{grade}}",
          points: "Puntos",
          classification: "Clasificación",
          criterion: "Criterio",
          band: "Franja",
          riskCategory: "Categoría de riesgo",
          riskCategoryCri: "Categoría de riesgo (CRI)",
        },
        criPanel: {
          tableTitle: "Cuadro 1 - Clasificación para presas de minería",
          ctRow: "Características técnicas (CT)",
          ecRow: "Estado de conservación (EC)",
          psRow: "Plan de seguridad de presas (PS)",
          totalFormula: "Puntuación total (CRI) = CT + EC + PS",
          riskClassification: "Clasificación de riesgo",
          bandsTitle: "Franjas de clasificación",
          bandHigh: ">= 80 o EC = 10 (*)",
          bandMedium: "40 < CRI < 80",
          bandLow: "<= 40",
          footnote:
            "(*) Una puntuación (10) en cualquier columna de estado de conservación (EC) implica automáticamente CATEGORÍA DE RIESGO ALTA y la necesidad de medidas inmediatas por el responsable de la presa",
        },
        dpaPanel: {
          tableTitle: "Clasificación para presas de minería",
          damageCategoryDpa: "Daño potencial asociado (DPA)",
          volumeRow: "Volumen total del embalse",
          populationRow: "Existencia de población aguas abajo",
          environmentalRow: "Impacto ambiental",
          socioeconomicRow: "Impacto socioeconómico",
          totalLabel: "Puntuación total (DPA)",
          damageClassification: "Clasificación de daño",
          bandsTitle: "Franjas de clasificación",
          damageCategory: "Daño potencial asociado",
          bandHigh: ">= 13",
          bandMedium: "7 < DPA < 13",
          bandLow: "<= 7",
          matrixFooter: "Matriz de clasificación",
        },
        goClassification: {
          aa: "AA",
          a: "A",
          b: "B",
          c: "C",
          d: "D",
        },
        goPanel: {
          tableTitle: "Cuadro 6 - Clasificación respecto a la gestión operacional",
          operationalCategory: "Gestión operacional (GO)",
          risrRow: "Declaración de condición de estabilidad RISR enviada",
          rpsbRow: "Declaración de condición de estabilidad RPSB enviada",
          conformityRow: "Declaración de conformidad y operacionalidad enviada",
          inspectionRow: "Extracto de inspección enviado",
          edrRow: "Existencia de EdR",
          pgrbmRow: "Programa de Gestión de Riesgo para Presas de Minería — PGRBM",
          certificationRow: "Certificación y/o estándares de la industria",
          totalLabel: "Puntuación total (GO)",
          operationalClassification: "Clasificación de gestión operacional",
          bandsTitle: "Franjas de clasificación",
          gopCategory: "GOP",
          bandAa: "0",
          bandA: "1 a 7",
          bandB: "8 a 35",
          bandC: "36 a 59",
          bandD: ">= 60 (*)",
          footnote:
            "(*) Presa que debiera estar registrada en CNBM y sea descubierta en acción fiscalizadora permanecerá en clase D por 6 meses subsiguientes.",
        },
        validation: {
          incompleteSelectionTitle: "Selección incompleta",
          incompleteSelectionDescription:
            "Seleccione una tarjeta en cada columna de todas las gradas (CRI, DPA y Gestión operacional) antes de guardar.",
        },
        catalog: anmClassificationCatalogEsES,
      },
      regionalClassification: {
        classification: {
          high: "Alto",
          medium: "Medio",
          low: "Bajo",
        },
        state: {
          label: "Estado",
          placeholder: "Seleccione el estado",
          mg: "Minas Gerais",
        },
        norm: {
          label: "Norma",
          placeholder: "Seleccione la norma",
          locked: "Norma fijada tras el primer guardado.",
        },
        label: {
          criBignumberTitle: "Categoría de riesgo (CRI)",
          secondBignumberTitle: "Daño potencial",
          referenceDocButton: "Documentación de referencia {{section}}",
          referenceDocPanel: "Documentación de referencia — {{section}}",
          close: "Cerrar",
          total: "Total {{section}}",
          classificationStatus: "Clasificación {{section}}",
          partial: "Parcial {{grade}}",
          points: "Puntos",
          classification: "Clasificación",
          criterion: "Criterio",
          band: "Franja",
          riskCategory: "Categoría de riesgo",
          riskCategoryCri: "Categoría de riesgo (CRI)",
        },
        criPanel: {
          sectionRowNumber: "1",
          gradeRowNumber: "1.{{index}}",
          totalFormula: "Puntuación total (CRI) = CT + EC + PSB",
          bandsTitle: "Franjas de clasificación",
          bandHigh: ">= {{highMin}} o EC = {{ecScore}} (*)",
          bandMedium: "{{mediumMin}} < CRI < {{highMin}}",
          bandLow: "<= {{mediumMin}}",
          footnote:
            "(*) Una puntuación de ({{ecScore}}) o superior en cualquier columna de estado de conservación (EC) implica automáticamente CATEGORÍA DE RIESGO ALTA y la necesidad de medidas preventivas inmediatas por el responsable de la presa",
        },
        secondPanel: {
          sectionRowNumber: "2",
          criterionRowNumber: "2.{{index}}",
          damageCategory: "Daño potencial asociado ({{section}})",
          totalLabel: "Puntuación total ({{section}})",
          damageClassification: "Clasificación de daño",
          bandsTitle: "Franjas de clasificación",
          bandHigh: ">= {{highMin}}",
          bandMedium: "{{mediumMin}} < {{section}} < {{highMin}}",
          bandLow: "<= {{mediumMin}}",
          matrixFooter: "Matriz de clasificación",
        },
        validation: {
          incompleteSelectionTitle: "Selección incompleta",
          incompleteSelectionDescription:
            "Seleccione una tarjeta en cada columna de todas las grillas (CRI y PDA/DPA) antes de guardar.",
          stateRequired: "Seleccione el estado",
          normRequired: "Seleccione la norma",
          normLocked: "La norma no puede cambiarse tras el primer guardado.",
        },
        catalog: regionalClassificationCatalogEsES,
      },
      riskMapping: {
        label: {
          wasteType: "Tipo de residuos",
          downstreamHumanOccupation:
            "Ocupación humana aguas abajo de la presa",
          downstreamEnvironmentalInterest:
            "Interés ambiental en el área aguas abajo de la presa",
          downstreamInstallation:
            "Instalación en el área aguas abajo de la presa",
        },
        validation: {
          wasteTypeRequired: "Indique el tipo de residuos",
          downstreamHumanOccupationRequired:
            "Indique la ocupación humana aguas abajo de la presa",
          downstreamEnvironmentalInterestRequired:
            "Indique el interés ambiental aguas abajo de la presa",
          downstreamInstallationRequired:
            "Indique la instalación aguas abajo de la presa",
        },
      },
      hydrology: {
        label: {
          maximumMaximorumLevel: "N.A. Máximo maximorum (m)",
          criticalDuration: "Duración crítica (h)",
          inflowRate: "Caudal afluente (m³/s)",
          outflowRate: "Caudal efluente (m³/s)",
          designRainfall: "Lluvia de proyecto (mm)",
          contributingBasinArea: "Cuenca de contribución (km²)",
          returnPeriod: "Período de retorno (años)",
          totalVolumeAtCrestElevation: "Volumen total en la elevación de la cresta (m³)",
          spillwayType: "Tipo de aliviadero",
          spillwaySill: "Umbral del aliviadero (mm)",
          referenceDocument: "Documento de referencia",
        },
        spillwayType: {
          surface: "Superficie",
          tulip: "Tulipán",
          lateralChannel: "Canal lateral",
          labyrinth: "Laberinto",
          gated: "Con compuertas",
          bottom: "Fondo",
        },
        validation: {
          maximumMaximorumLevelRequired: "Indique el N.A. máximo maximorum",
          criticalDurationRequired: "Indique la duración crítica",
          inflowRateRequired: "Indique el caudal afluente",
          outflowRateRequired: "Indique el caudal efluente",
          designRainfallRequired: "Indique la lluvia de proyecto",
          contributingBasinAreaRequired: "Indique la cuenca de contribución",
          returnPeriodRequired: "Indique el período de retorno",
          totalVolumeAtCrestElevationRequired:
            "Indique el volumen total en la elevación de la cresta",
          spillwayTypeRequired: "Seleccione el tipo de aliviadero",
          spillwaySillRequired: "Indique el umbral del aliviadero",
          referenceDocumentRequired: "Indique el documento de referencia",
          decimalInvalid:
            "Indique un número válido (use punto o coma como separador decimal)",
        },
      },
    },
    users: {
      button: {
        new: "Nuevo Usuario",
        save: "Guardar",
        cancel: "Cancelar",
        edit: "Editar",
        delete: "Eliminar",
        filter: "Filtrar",
        clearFilters: "Limpiar Filtros",
      },
      form: {
        label: {
          name: "Nombre",
          email: "Correo electrónico",
          phone: "Teléfono",
          department: "Departamento",
          position: "Cargo",
          userType: "Tipo de usuario",
        },
        placeholder: {
          name: "Nombre Apellido",
          email: "nombre@empresa.com",
          emailTellus: "nombre.apellido@telluscompany.com.br",
          userTypeSelect: "Seleccione...",
          department: "Ingeniería Digital",
          position: "Diseñador UX/UI",
          filterName: "Escriba el nombre",
          filterEmail: "Escriba el correo electrónico",
        },
      },
      table: {
        filterButtonText: "Filtros",
        column: {
          name: "Nombre",
          email: "Correo electrónico",
          role: "Tipo de Acceso",
          userType: "Tipo",
          department: "Departamento",
          position: "Cargo",
        },
      },
      modal: {
        title: {
          create: "Crear usuario",
          edit: "Editar usuario",
        },
      },
      userType: {
        client: "Cliente",
        tellus: "Tellus",
      },
      validation: {
        nameRequired: "El nombre es obligatorio (mínimo 2 caracteres)",
        emailRequired: "El correo electrónico es obligatorio",
        emailInvalid: "Correo electrónico inválido",
        emailTellusDomain: "El correo electrónico debe pertenecer al dominio @telluscompany.com.br",
        phoneRequired: "El teléfono es obligatorio (mínimo 8 caracteres)",
      },
    },
    licenseInventory: {
      page: {
        title: "Inventario de licencias",
        subtitle:
          "Visualice las licencias contratadas por complejo, estructura y módulo, con cantidades totales, usadas y disponibles.",
      },
      table: {
        filterButtonText: "Filtros",
        column: {
          complex: "Complejo",
          structure: "Estructura",
          module: "Módulo",
          validity: "Vigencia",
          quantity: "Total",
          used: "Usadas",
          available: "Disponibles",
        },
      },
      filter: {
        label: {
          complex: "Complejo",
          structure: "Estructura",
          module: "Módulo",
          onlyActive: "Solo licencias vigentes",
        },
        placeholder: {
          complex: "Escriba el nombre del complejo",
          structure: "Escriba el nombre de la estructura",
          module: "Escriba el nombre del módulo",
        },
        button: {
          filter: "Filtrar",
          clearFilters: "Limpiar Filtros",
        },
      },
    },
    licenseAssignments: {
      page: {
        title: "Asignaciones de licencia",
        subtitle:
          "Asigne y revoque licencias a usuarios del tenant. Cada asignación consume una unidad de la cantidad contratada.",
      },
      button: {
        assign: "Asignar licencia",
        revoke: "Revocar",
      },
      table: {
        filterButtonText: "Filtros",
        column: {
          assigneeName: "Usuario",
          assigneeEmail: "Correo electrónico",
          complex: "Complejo",
          structure: "Estructura",
          module: "Módulo",
          validity: "Vigencia",
        },
      },
      filter: {
        label: {
          complex: "Complejo",
          structure: "Estructura",
          module: "Módulo",
          user: "Usuario",
        },
        placeholder: {
          complex: "Escriba el nombre del complejo",
          structure: "Escriba el nombre de la estructura",
          module: "Escriba el nombre del módulo",
          user: "Escriba el nombre del usuario",
        },
        button: {
          filter: "Filtrar",
          clearFilters: "Limpiar Filtros",
        },
      },
      modal: {
        assignTitle: "Asignar licencia",
        revokeTitle: "Revocar asignación",
        revokeMessage:
          "¿Está seguro de revocar esta asignación? La licencia volverá a estar disponible.",
      },
      form: {
        label: {
          user: "Usuario",
          license: "Licencia (complejo / estructura / módulo)",
        },
        placeholder: {
          selectUser: "Seleccione un usuario...",
          selectLicense: "Seleccione una licencia...",
        },
        validation: {
          userRequired: "Seleccione un usuario",
          licenseRequired: "Seleccione una licencia",
        },
        licenseOption: {
          available: "disponibles",
        },
        licenseEmpty: "No hay licencias vigentes disponibles.",
      },
    },
    permissions: {
      page: {
        title: "Permisos granulares",
        subtitle:
          "Defina, para cada usuario, qué acciones puede realizar en cada módulo de una estructura específica.",
      },
      form: {
        label: {
          complex: "Complejo",
          structure: "Estructura",
          user: "Usuario",
        },
        placeholder: {
          selectComplex: "Seleccione un complejo...",
          selectStructure: "Seleccione una estructura...",
          selectUser: "Seleccione un usuario...",
        },
      },
      empty: {
        selectAll: "Seleccione complejo, estructura y usuario para continuar.",
      },
      error: {
        load: "Error al cargar los permisos. Verifique que tenga acceso al complejo seleccionado.",
      },
      grid: {
        empty: "Ningún módulo disponible para esta combinación.",
        badge: {
          unavailable: "No disponible en esta estructura",
        },
        module: {
          noKeys: "No hay clave de permiso definida para este módulo.",
        },
      },
      button: {
        save: "Guardar permisos",
      },
    },
  },
};
